import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

import { useForm } from 'react-hook-form';

import { Helmet } from 'react-helmet';

import { toast } from 'react-toastify';

import Swal from 'sweetalert2';

import api from '~/services/api';
import history from '~/services/history';

import { BoxAuth, PageTitle, Left, BoxLabel, Label } from './style';

import Breadcumbs from '~/components/Breadcumbs';

export default function Recovery() {
  const { register, handleSubmit, errors } = useForm();
  // const dispath = useDispatch();
  const loading = useSelector(state => state.auth.loading);

  const [authError, setAuthError] = useState(false);

  const [passwordError, setPasswordError] = useState(false);

  const tokenUrl = window.location.search;

  const token = tokenUrl.split('=')[1];

  useEffect(() => {
    if (authError) {
      setTimeout(() => {
        setAuthError(false);
      }, 5000);
    }
  }, [authError]);

  useEffect(() => {
    if (passwordError) {
      setTimeout(() => {
        setPasswordError(false);
      }, 5000);
    }
  }, [passwordError]);

  const onSubmit = async ({ password, confirmPassword }) => {
    if (password !== confirmPassword) {
      Swal.fire({
        title: 'Atenção',
        text: 'As senhas devem ser iguais.',
        icon: 'warning',
        confirmButtonColor: '#74a50a',
      });
      setPasswordError(true);

      return;
    }

    if (!password) {
      toast.error('A nova senha é obrigatória.', { autoClose: true });
      setPasswordError(true);
      return;
    }

    if (!confirmPassword) {
      toast.error('A confirmação da senha é obrigatória.', { autoClose: true });
      setPasswordError(true);
      return;
    }

    try {
      await api
        .post('/autenticacao/alterar-senha', {
          token: String(token),
          senha: String(password),
          confirmeSenha: String(confirmPassword),
        })
        .then(res => {
          if (res.status === 200) {
            Swal.fire({
              title: 'Sucesso',
              text: 'Sua senha foi alterada com sucesso.',
              icon: 'success',
              confirmButtonColor: '#74a50a',
            }).then(() => {
              history.push('/');
            });
          }
        });
    } catch (error) {
      const { cause } = error.response.data;

      if (cause === 'not_found') {
        Swal.fire({
          title: '',
          text: `${error.response.data.error}`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
        }).then(() => {
          window.location.reload();
        });

        return;
      }

      Swal.fire({
        title: 'Atenção, verifique seu dados.',
        text:
          'A senha deve ter no mínimo 8 (oito) caracteres, contendo letras maiúsculas, minúsculas, números de 0 a 9 e caracteres especiais.',
        icon: 'error',
        confirmButtonColor: '#74a50a',
      }).then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Recuperação de senha | SIHOSP - Sistema de Indicadores Hospitalares
        </title>
      </Helmet>
      <Breadcumbs path="recuperar-senha" pathTitle="Recuperação de senha" />
      <PageTitle>
        <span>Recuperação de senha</span>
      </PageTitle>
      <BoxAuth>
        <Left>
          <h4>
            Informe sua <strong> nova senha</strong>.
          </h4>

          <form onSubmit={handleSubmit(onSubmit)}>
            <BoxLabel>
              <Label>Nova senha:</Label>
              <span
                className="notice"
                style={{ color: authError || passwordError ? '#cc0000' : null }}
              >
                *Preenchimento obrigatório
              </span>
            </BoxLabel>

            <input
              name="password"
              ref={register}
              type="password"
              style={{
                borderColor: authError || passwordError ? '#cc0000' : null,
              }}
            />

            {errors.cpf ? (
              <span>
                (A senha deve ter no mínimo 8 (oito) caracteres, contendo letras
                maiúsculas, minúsculas, números de 0 a 9 e caracteres especiais)
              </span>
            ) : (
              <span className="noticeInfo">
                (A senha deve ter no mínimo 8 (oito) caracteres, contendo letras
                maiúsculas, minúsculas, números de 0 a 9 e caracteres especiais)
              </span>
            )}

            <BoxLabel>
              <Label>Repita a senha:</Label>
              <span
                className="notice"
                style={{ color: authError || passwordError ? '#cc0000' : null }}
              >
                *Preenchimento obrigatório
              </span>
            </BoxLabel>

            <input
              name="confirmPassword"
              type="password"
              ref={register}
              style={{
                borderColor: authError || passwordError ? '#cc0000' : null,
              }}
            />

            {errors.password ? (
              <span>
                (A senha deve ter no mínimo 8 (oito) caracteres, contendo letras
                maiúsculas, minúsculas, números de 0 a 9 e caracteres
                especiais).
              </span>
            ) : (
              <span className="noticeInfo">
                (A senha deve ter no mínimo 8 (oito) caracteres, contendo letras
                maiúsculas, minúsculas, números de 0 a 9 e caracteres especiais)
              </span>
            )}

            <div className="ButtonBox">
              <button type="submit">
                {loading ? 'Enviando...' : 'Enviar'}
              </button>
              <Link to="/">Fazer login</Link>
            </div>
          </form>
        </Left>
      </BoxAuth>
    </>
  );
}
